import { MEDIUM_BLUE } from 'constants/colors';

const GRAPH_CONFIG_MAP: Record<
string,
{
  type: 'line' | 'bar';
  smooth?: boolean;
  getItemStyle?: (value: number) => { color: string };
  lineColor?: string;
  yAxisUnit?: string;
}
> = {
  arm: {
    type: 'line',
    smooth: true,
    lineColor: MEDIUM_BLUE,
    yAxisUnit: '%',
  },
  etc: {
    type: 'line',
    smooth: true,
    lineColor: '#006400',
    yAxisUnit: 'mm',
  },
  def_x_exc: {
    type: 'bar',
    getItemStyle: (value: number) => ({
      color: value >= 0 ? MEDIUM_BLUE : '#d32f2f',
    }),
    yAxisUnit: 'mm',
  },
  chuva: {
    type: 'bar',
    lineColor: MEDIUM_BLUE,
    yAxisUnit: 'mm',
  },
  temperatura: {
    type: 'line',
    smooth: true,
    lineColor: '#006400',
    yAxisUnit: '°C',
  },
  graus_dia: {
    type: 'line',
    smooth: true,
    lineColor: '#d32f2f',
    yAxisUnit: '°C',
  },
};

export default GRAPH_CONFIG_MAP;
